export default __webpack_public_path__ + "static/media/info.d937d603.svg";